import { Flex, Radio } from '@chakra-ui/react';
import React from 'react';
import './CustomRadioButton.scss';

export interface CustomRadioButtonProps {
  label: string;
  value: string;
}

const CustomRadioButton = ({ label, value }: CustomRadioButtonProps) => {
  return (
    <Flex
      className={`custom-radio-button-container 
      `}
    >
      {/*Label is located inside radio button so that it will be clickable*/}
      <Radio
        value={value}
        className={`custom-radio-button form-control 
        `}
      >
        {label}
      </Radio>
    </Flex>
  );
};

export default CustomRadioButton;
